/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

import styles from './cornering-position-icon.module.css'

const propTypes = {
    eventSeverity: PropTypes.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48,
    eventSeverity: 'default'
}

/**
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <...Icon width={12} />
 */
const CorneringPositionIcon = props => {
    const { eventSeverity } = props
    return (
        <SvgIcon {...props} className={styles['cornering-position-pin']}>
            <g>
                <path
                    className={styles['icon-foreground']}
                    d={`M37.528,7.876c-3.459-3.435-8.236-5.561-13.511-5.561c-5.278,0-10.056,2.126-13.514,5.564
            c-3.459,3.436-5.598,8.185-5.598,13.43c0,5.246,2.144,9.996,5.603,13.434C13.967,38.18,24.017,46,24.017,46
            S34.07,38.177,37.53,34.739c3.459-3.439,5.598-8.186,5.598-13.431C43.128,16.063,40.988,11.314,37.528,7.876`}
                />
                <path
                    className={styles[eventSeverity]}
                    d={`M36.627,8.811c-3.228-3.206-7.686-5.19-12.611-5.19c-4.926,0-9.386,1.985-12.613,5.192
            c-3.228,3.207-5.225,7.64-5.225,12.535c0,4.896,2.001,9.33,5.23,12.539c3.228,3.207,12.608,10.506,12.608,10.506
            s9.384-7.301,12.613-10.51c3.228-3.21,5.225-7.64,5.225-12.535C41.854,16.452,39.857,12.02,36.627,8.811`}
                />
                <g>
                    <path
                        className={styles['icon-foreground']}
                        d={`M27.269,13.635c-0.014-1.948,2.149-5.373,2.149-5.373h-4.312c0,0-6.491,3.094-6.491,6.384
                c0,3.291,3.253,5.435,3.254,6.46c0.001,2.015-8.597,8.646-8.597,8.646h18.267c0,0,3.224-6.783,3.224-8.596
                C34.762,17.127,27.275,14.585,27.269,13.635z M26.09,9.337h0.915c0,0-1.53,0.759-2.368,2.115h-1.517
                C24.291,10.164,26.09,9.337,26.09,9.337z M23.8,14.676c0.582,1.645,3.862,2.451,4.858,4.332h-1.931
                c-0.688-1.657-3.654-1.836-4.459-4.332H23.8z M24.233,28.678h-2.149c0,0,5.118-4.332,5.451-6.47l1.559,0.022
                C28.34,25.233,24.233,28.678,24.233,28.678z`}
                    />
                </g>
            </g>
        </SvgIcon>
    )
}

CorneringPositionIcon.defaultProps = defaultProps
CorneringPositionIcon.propTypes = propTypes

export { CorneringPositionIcon }
